import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  actions: {
    pushNotificationTopic(_, noti) {
      return axiosIns.post('notifications/push/topic', noti)
    },
    getUserFcmToken(_, { userType, externalId }) {
      return axiosIns.get(`notifications/fcm/${userType}/${externalId}`)
    },
    subscribetoFcm(_, fcmToken) {
      return axiosIns.post('notifications/fcm/subscribe', {
        token: fcmToken,
        user_type: 'test',
      })
    },
    fetchNotification(_, logId) {
      return axiosIns.get('/notifications/details', {
        params: {
          log_id: logId,
        },
      })
    },
    async fetchNotifications(_, params) {
      const res = (await axiosIns.get('/notifications/get-log', {
        params,
      })).data.data.data
      return res
    },
    pushIndividualNotification(_, indNotification) {
      return axiosIns.post('/notifications/push/individual', indNotification)
    },
    createDraft(_, noti) {
      return axiosIns.post('notifications/create-draft', noti)
    },
    updateDraft(_, draftNoti) {
      return axiosIns.patch('/notifications/update-draft', draftNoti)
    },
  },
}
